var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component graphcomponent"},[_c('apexchart',{attrs:{"width":"100%","height":_vm.graphHeight||'100%',"type":"bar","options":_vm.graphOptions,"series":_vm.graphData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }